import { render, staticRenderFns } from "./verificationPage.vue?vue&type=template&id=6f2c6b84&"
import script from "./verificationPage.vue?vue&type=script&lang=js&"
export * from "./verificationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports